import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef } from '@angular/core';
import { VisionVO } from '@wizeoo/akm-compute-lib';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Model } from 'src/app/model/model';
import { BusinessUnitVO } from '@wizeoo/akm-common-lib';


@Component({
  selector: 'bu-icon-renderer',
  template: ` <wiz-hgroup
    #hgContainer
    height="100%"
    width="100%"
    verticalAlign="center"
    gap="3"
    >
    <wiz-image width="24px" height="24px" [sourceObservable]="bu.iconOrDie" style="align-self: center;"></wiz-image>
    <wiz-label [wizLabel]="bu.name" [wizTextBehavior]="'truncate'"></wiz-label>
  </wiz-hgroup>`,
  styles: [':host {max-width: 100%}'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

/**
 * Renderer des actions sur une application dans le grid
 */
export class BuIconRenderer implements AgRendererComponent {
  constructor(private cdref: ChangeDetectorRef, public elementRef: ElementRef) {}

  public bu: BusinessUnitVO = null;
  public vision: VisionVO = null;

  private feed(params: ICellRendererParams): void {
    this.vision = params.data;
    this.bu = Model.getInstance().businessUnitMap.get(this.vision.domain).filter(item => item.businessUnitCode === this.vision.businessUnitCode)[0];
    this.cdref.markForCheck();
  }

  refresh(params: ICellRendererParams): boolean {
    this.feed(params);
    return true;
  }

  agInit(params: ICellRendererParams) {
    this.feed(params);
  }
}
